'use client';
import { createBreakpointFns } from './fns/breakpoints/breakpoints.js';
import { darken } from './fns/darken/darken.js';
import { foreground } from './fns/foreground/foreground.js';
import { lighten } from './fns/lighten/lighten.js';
import { themeColor } from './fns/themeColor/themeColor.js';
import { border } from './fns/border/border.js';
import { borderRadius } from './fns/borderRadius/borderRadius.js';
import { focusRing } from './fns/focusRing/focusRing.js';
import { deriveShades } from './fns/deriveShades/deriveShades.js';
import { deriveStates } from './fns/deriveStates/deriveStates.js';
import { square } from './fns/square/square.js';
import { space } from './fns/space/space.js';
import { cover } from './fns/cover/cover.js';
import { transition } from './fns/transition/transition.js';
import { gradient } from './fns/gradient/gradient.js';
import { typography } from './fns/typography/typography.js';
import { responsive } from './fns/responsive/responsive.js';
import { primaryShade } from './fns/primaryShade/primaryShade.js';
import { rgba } from './fns/rgba/rgba.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var attachFunctions = function(theme) {
    var breakpointFns = createBreakpointFns(theme.breakpoints);
    var _theme = theme;
    _theme.fn = _extends({}, theme.fn, breakpointFns, {
        darken: darken,
        foreground: foreground,
        lighten: lighten,
        primaryShade: primaryShade,
        themeColor: themeColor(_theme),
        border: border(_theme),
        borderRadius: borderRadius(_theme),
        rgba: rgba,
        focusRing: focusRing(_theme),
        deriveShades: deriveShades(_theme),
        deriveStates: deriveStates(_theme),
        square: square(_theme),
        space: space(_theme),
        cover: cover,
        transition: transition(_theme),
        gradient: gradient(_theme),
        typography: typography(_theme),
        responsive: responsive(_theme)
    });
    return _theme;
};

export { attachFunctions };
